/**
 * Error Boundary — catches render errors and shows fallback UI
 */
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex align-items-center justify-content-center min-vh-100">
          <div className="text-center p-5">
            <div style={{ fontSize: '4rem' }}>😵</div>
            <h2 className="mt-3">Something went wrong</h2>
            <p className="text-muted">An unexpected error occurred. Please try refreshing the page.</p>
            <button className="btn btn-primary" onClick={() => window.location.reload()}>
              <i className="bi bi-arrow-clockwise me-1"></i>Refresh Page
            </button>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="text-start mt-4 p-3 bg-light rounded small text-danger" style={{ maxHeight: 200, overflow: 'auto' }}>
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
